import React, { Component, ComponentType } from 'react';
import { RouteComponentProps, withRouter } from 'react-router';
import { WithTranslation, withTranslation } from 'react-i18next';
import { connect, ConnectedProps } from 'react-redux';
import { compose } from 'redux';
import { RootState } from '../../store';
import { IEciImplantOutForecastContainerStateProps, IEciImplantOutForecastContainerDispatchProps } from '../../interfaces/props/IEciImplantDetailsProps';
import * as eciImplantOutForecastStore from '../../store/modules/eciImplantOutForecast.store';
import './eciImplantOutForecastDetails.container.scss';

import { FormValidator } from '@syncfusion/ej2-react-inputs';
import { IErrors } from '../../common/model/errors.model';
import { isIResponseError, getData, IResponseData, IFile } from '../../common/model/responseError.model';
import { eciImplantsService } from '../../services';
import { notifyErrorWithOptions, notifyInfoWithOptions, notifyWarningWithOptions } from '../../utils/toast.utils';
import { isNullOrWhitespace } from '../../utils/string.utils';
import { AxiosResponse } from 'axios';
import { DropDownListComponent, FieldSettingsModel } from '@syncfusion/ej2-react-dropdowns';

type EciImplantOutForecastContainerPropsType = PropsFromRedux & RouteComponentProps & WithTranslation;

class EciImplantOutForecastDetailsContainer extends Component<EciImplantOutForecastContainerPropsType> {
  public testTypeDropDownListComponent: DropDownListComponent = null;
  public testTypeFields: FieldSettingsModel = { text: 'Description', value: 'Code' };
  public testTypeOptions: { [key: string]: any }[] = [
    { Code: "2", Description: this.props.i18n.t('eciImplant.testTypes.items.costumesPPT') }, { Code: "3", Description: this.props.i18n.t('eciImplant.testTypes.items.costumesPST') },
    { Code: "5", Description: this.props.i18n.t('eciImplant.testTypes.items.hardGoodsPPT') }, { Code: "6", Description: this.props.i18n.t('eciImplant.testTypes.items.hardGoodsPST') }/*,
    { Code: "14", Description: this.props.i18n.t('eciImplant.testTypes.items.bigRetail') }*/
  ];

  public filesToUpload: HTMLInputElement = null;
  public files: FileList;

  private readonly UPLOAD_ECI_OUT_SELECTION_APPFORM_FORM_ID = 'EciImplantOutForecastAppFormForm';
  private formValidatorOutForecast: FormValidator = null;
  private formValidator: FormValidator = null;
  private isValidatingAll = false;
  private auxErrors: IErrors = {};

  public constructor(props: EciImplantOutForecastContainerPropsType) {
    super(props);
  }

  public closeOutForecast(): void {
    this.formValidatorOutForecast = null;
  }

  public close(): void {
    this.formValidator = null;
  }

  private validateForm(): boolean {
    const { setErrors } = this.props;
    if (!this.formValidator) {
      return true;
    }

    this.isValidatingAll = true;
    const isFormValid = this.formValidator.validate();
    this.isValidatingAll = false;

    if (!isFormValid) {
      setErrors(this.auxErrors);
      this.auxErrors = {};
    } else {
      setErrors({});
    }

    return isFormValid;
  }

  private validateOutForecastForm(): boolean {
    const { setErrors } = this.props;
    if (!this.formValidator) {
      return true;
    }

    this.isValidatingAll = true;
    const isFormValid = this.formValidatorOutForecast.validate();
    this.isValidatingAll = false;

    if (!isFormValid) {
      setErrors(this.auxErrors);
      this.auxErrors = {};
    } else {
      setErrors({});
    }

    return isFormValid;
  }

  public onFileChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const maxFilesCount = 5;
    const files = event.target.files;
    const { i18n } = this.props

    if (files && files.length > maxFilesCount) {
      notifyErrorWithOptions(i18n.t('eciImplant.uploadMaxFilesCount').replace('{0}', maxFilesCount.toString()).replace('{1}', files.length.toString()), { autoClose: false });
      event.target.value = '';
    } else {
      this.files = files;
    }
  };

  public async uploadFilledOutForecastAppForm(e: React.FormEvent<HTMLFormElement>): Promise<void> {
    e.preventDefault();

    const { i18n, setSpinnerUploadOutForecastAppForm, user } = this.props

    setSpinnerUploadOutForecastAppForm(true);

    try {
      const testType = this.testTypeDropDownListComponent.value as string;

      await eciImplantsService.uploadFilesToQueue(this.files, testType, user.email);

      notifyInfoWithOptions(i18n.t('eciImplant.uploadOutForecastAppFormSuccess'), { autoClose: false });

      this.files = null;
      this.filesToUpload.value = '';
    } catch (ex) {
      let errors: IErrors = {};
      let response: AxiosResponse = null;
      if (isIResponseError(ex)) {
        errors = ex.errors;
        response = ex.bodyResponse
      } else {
        errors = ex as IErrors;
      }

      if (response) {
        getData(response).then((data: IResponseData) => {
          const message = data !== undefined && data != null
            ? data.error !== undefined && data.error != null
              ? data.error.message !== undefined && data.error.message != null && data.error.message.trim() != ''
                ? data.error.message
                : data.error.messageException
              : ''
            : 'The response does not have a defined message';

          if (!isNullOrWhitespace(message)) {
            notifyErrorWithOptions(`${i18n.t('eciImplant.uploadOutForecastAppFormError')}. ERROR: ${message}`, { autoClose: false });
          } else {
            notifyErrorWithOptions(`${i18n.t('eciImplant.uploadOutForecastAppFormError')}.`, { autoClose: false });
          }
        });
      } else {
        notifyErrorWithOptions(`${i18n.t('eciImplant.uploadOutForecastAppFormError')}. ERROR: ${errors}`, { autoClose: false });
      }
    } finally {
      setSpinnerUploadOutForecastAppForm(false);
    }
  }

  private GetBlobFile(file: IFile): Blob {
    if (file !== undefined && file != null && file.stream !== undefined && file.stream != null) {
      // Convertir el archivo base64 a un Blob
      const byteCharacters = atob(file.stream);
      const byteNumbers = new Array(byteCharacters.length);
      for (let i = 0; i < byteCharacters.length; i++) {
        byteNumbers[i] = byteCharacters.charCodeAt(i);
      }
      const byteArray = new Uint8Array(byteNumbers);
      const blob = new Blob([byteArray], { type: file.mimeType });

      return blob;
    }

    return null;
  }

  public async downloadGarmentsTemplateClick(): Promise<void> {
    try {
      await eciImplantsService.downloadEciTemplateGarmentsFile();
    } catch (ex) {
      let response: AxiosResponse = null;
      if (isIResponseError(ex)) {
        response = ex.bodyResponse
      }

      if (response) {
        getData(response).then((data: IResponseData) => {
          const message = data !== undefined && data != null
            ? data.error !== undefined && data.error != null
              ? data.error.message !== undefined && data.error.message != null && data.error.message.trim() != ''
                ? data.error.message
                : data.error.messageException
              : ''
            : 'The response does not have a defined message';

          const file = this.GetBlobFile(data.file);

          if (file != null) {
            const url = window.URL.createObjectURL(file);
            const link = document.createElement('a');
            link.href = url;
            link.download = data.file.fileName;
            link.click();
            window.URL.revokeObjectURL(url);

            notifyWarningWithOptions(message.replace(/<[^>]*>?/gm, ''), { autoClose: false });
          } else {
            notifyErrorWithOptions(message.replace(/<[^>]*>?/gm, ''), { autoClose: false });
          }
        });
      }
    }
  }

  public async downloadShoesTemplateClick(): Promise<void> {
    try {
      await eciImplantsService.downloadEciTemplateShoesFile();
    } catch (ex) {
      let response: AxiosResponse = null;
      if (isIResponseError(ex)) {
        response = ex.bodyResponse
      }

      if (response) {
        getData(response).then((data: IResponseData) => {
          const message = data !== undefined && data != null
            ? data.error !== undefined && data.error != null
              ? data.error.message !== undefined && data.error.message != null && data.error.message.trim() != ''
                ? data.error.message
                : data.error.messageException
              : ''
            : 'The response does not have a defined message';

          const file = this.GetBlobFile(data.file);

          if (file != null) {
            const url = window.URL.createObjectURL(file);
            const link = document.createElement('a');
            link.href = url;
            link.download = data.file.fileName;
            link.click();
            window.URL.revokeObjectURL(url);

            notifyWarningWithOptions(message.replace(/<[^>]*>?/gm, ''), { autoClose: false });
          } else {
            notifyErrorWithOptions(message.replace(/<[^>]*>?/gm, ''), { autoClose: false });
          }
        });
      }
    }
  }

  public render() {
    const {
      i18n,
      showSpinnerUploadOutForecastFile
    } = this.props;

    return (
      <div>
        <div>
          <div dangerouslySetInnerHTML={{ __html: i18n.t('eciImplant.infoUploadAppForm') }}></div>
          <form id={this.UPLOAD_ECI_OUT_SELECTION_APPFORM_FORM_ID} encType="multipart/form-data" onSubmit={(e: React.FormEvent<HTMLFormElement>) => { e.preventDefault(); this.uploadFilledOutForecastAppForm(e); }}>
            <fieldset id='m2'>
              <legend>
                {i18n.t('eciImplant.uploadOutForecastAppForm')}
                <div className='buttonsInLegend'>
                  <button className='btn btn-sm btn-light' title={i18n.t('eciImplant.downloadGarmentAppForm')} onClick={(e: React.MouseEvent<HTMLButtonElement>) => { e.preventDefault(); this.downloadGarmentsTemplateClick(); }}>
                    <span className='icon icon-app-file-download'></span>
                  </button>
                  <button className='btn btn-sm btn-light' title={i18n.t('eciImplant.downloadShoesAppForm')} onClick={(e: React.MouseEvent<HTMLButtonElement>) => { e.preventDefault(); this.downloadShoesTemplateClick(); }}>
                    <span className='icon icon-app-file-download'></span>
                  </button>
                </div>
              </legend>
              <div dangerouslySetInnerHTML={{ __html: i18n.t('eciImplant.uploadOutForecastAppFormDescription') }}></div>
              <div className='row'>
                <div className='col'>
                  <div className='form-group marginLeftOutForecast'>
                    <div className='autocomplete-input'>
                      <div className='autocomplete-label'>{i18n.t('eciImplant.testTypes.text')}</div>
                      <DropDownListComponent
                        ref={(dropDownListComponent) => {
                          this.testTypeDropDownListComponent = dropDownListComponent;
                        }}
                        name="TestType"
                        dataSource={this.testTypeOptions}
                        fields={this.testTypeFields}
                        value={this.testTypeOptions[0].Code}
                      />
                    </div>
                  </div>
                </div>
                <div className='col'></div>
              </div>
              <div className='row'>
                <div className='col'>
                  <div className='form-group marginLeftOutForecast'>
                    <div className='autocomplete-input'>
                      <div className='autocomplete-label'>{i18n.t('eciImplant.filledAppForm')}</div>
                      <input type='file'
                        ref={(element: HTMLInputElement): HTMLInputElement => this.filesToUpload = element}
                        onChange={this.onFileChange}
                        accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
                        multiple
                      >
                      </input>
                    </div>
                  </div>
                </div>
                <div className='col'>
                  <button role='submit'
                    className='btn btn-sm btn-light'
                    title={i18n.t('eciImplant.uploadFilledAppForm')}
                    disabled={showSpinnerUploadOutForecastFile}
                  >
                    <span className={(showSpinnerUploadOutForecastFile ? 'spinner-border spinner-border-sm' : 'icon icon-app-action-send-email')}></span>
                  </button>
                </div>
              </div>
            </fieldset>
          </form>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state: RootState): IEciImplantOutForecastContainerStateProps => ({
  errors: state.eciImplantOutForecastStore.errors,
  user: state.currentUserStore.user,
  showSpinnerUploadOutForecastFile: state.eciImplantOutForecastStore.uploadOutForecastFileSpinner
});

const mapDispatchToProps: IEciImplantOutForecastContainerDispatchProps = {
  setSpinnerUploadOutForecastAppForm: eciImplantOutForecastStore.spinnerUploadOutForecastAppForm,
  setErrors: eciImplantOutForecastStore.setErrorsInState
};

const connector = connect(mapStateToProps, mapDispatchToProps);

type PropsFromRedux = ConnectedProps<typeof connector>;

export default compose(
  withRouter,
  withTranslation(),
  connector
)(EciImplantOutForecastDetailsContainer) as ComponentType;
